import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import OldAccountDetailsPage from './OldAccountDetailsPage';
import {
  saveOldAccountDetailsForm,
  oldSignatoriesSelector
} from '../../infrastructure/oldSignatories';
import {
  OLD_ACCOUNT_DETAILS_INFO,
  OLD_SIGNATORIES_KEYS,
  GET_CUSTOMER_KEY
} from '../../utils/constants';
import { selectors as caseSelector } from '../../infrastructure/cases';
import { fetchCustomerById } from '../../infrastructure/customers';

class OldAccountDetailsSection extends Component {
  constructor(props) {
    super(props);
    this.goToNextPage = this.goToNextPage.bind(this);
  }

  goToNextPage(data) {
    this.props.saveOldAccountDetailsForm(data, this.props.isSoleTrader);
  }

  componentDidMount() {
    const { fetchCustomerById, personalId, oldSignatories } = this.props;
    if (oldSignatories.length === 0) {
      fetchCustomerById(personalId, GET_CUSTOMER_KEY);
    }
  }

  render() {
    const { bankId, brandId, getBusinessData, isSoleTrader } = this.props;

    return (
      <OldAccountDetailsPage
        brandId={brandId}
        bankId={bankId}
        saveOldAccountDetailsForm={this.goToNextPage}
        getBusinessData={getBusinessData}
        isSoleTrader={isSoleTrader}
      />
    );
  }
}

OldAccountDetailsSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveOldAccountDetailsForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveOldAccountDetailsForm,
  fetchCustomerById
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  isSoleTrader: caseSelector.isSoleTrader(state),
  getBusinessData: oldSignatoriesSelector.getBusinessData(state, OLD_ACCOUNT_DETAILS_INFO),
  oldSignatories: oldSignatoriesSelector.getBusinessData(state, OLD_SIGNATORIES_KEYS),
  personalId: caseSelector.getPersonalCustomerId(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OldAccountDetailsSection);
